import {
  FormControl,
  FormLabel,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
} from '@chakra-ui/react'
import { Controller, UseFormReturn } from 'react-hook-form'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'

type ValidationsProps = {
  formMethods: UseFormReturn<CustomFormQuestion>
}

export default function MultipleFilesValidator({ formMethods }: ValidationsProps) {
  return (
    <>
      <FormControl display="flex" flexDir="column" gap={2}>
        <FormLabel fontWeight="bold">Mínimo arquivos permitidos</FormLabel>
        <Controller
          name="validation.min_file"
          control={formMethods.control}
          render={({ field }) => (
            <NumberInput
              {...field}
              value={field.value ?? 0}
              onChange={(valueString) => field.onChange(Number(valueString))}
            >
              <NumberInputField />
              <NumberInputStepper>
                <NumberIncrementStepper />
                <NumberDecrementStepper />
              </NumberInputStepper>
            </NumberInput>
          )}
        />
      </FormControl>

      <FormControl display="flex" flexDir="column" gap={2}>
        <FormLabel fontWeight="bold">Máximo arquivos permitidos</FormLabel>
        <Controller
          name="validation.max_file"
          control={formMethods.control}
          render={({ field }) => (
            <NumberInput
              {...field}
              value={field.value ?? 0}
              onChange={(valueString) => field.onChange(Number(valueString))}
            >
              <NumberInputField />
              <NumberInputStepper>
                <NumberIncrementStepper />
                <NumberDecrementStepper />
              </NumberInputStepper>
            </NumberInput>
          )}
        />
      </FormControl>
    </>
  )
}
